import { EventTypes, track } from '@mc/track-event'
import { convertKeysToSnakeCase } from '@mc/products'

import { PurchaseClickEventProps } from '../../types'

export const trackPurchaseClick = <T>({
  action,
  href,
  pageSource,
  location,
  ...rest
}: PurchaseClickEventProps & T) => {
  /*
   * PURCHASE CLICK PROPERTIES
   *
   * properties.action = “<cta text, e.g. ‘Get Started’>”
   * properties.href = "<url path of where the user is going to go when clicking cta, e.g. ‘/find-my-classes’>”
   * properties.location = Defined by data analysts. Please follow snake case convention
   * properties.page_source =  If page source value does not exist in PageSource, then ask Data Analyst people if that value is correct.
   *                           If so, then add the page source value as a new attribute in PageSource from @mc/track-event.
   * properties.page_path = "<url page path where CTA is, e.g. ‘/categories/trending’>"
   * properties.type = "all-access-pass" (Hardcoded value)
   * properties.class = "annual-pass" (Hardcoded value)
   *
   */
  const properties = {
    action,
    href,
    location,
    page_source: pageSource,
    page_path: window.location.href,
    type: 'all-access-pass',
    class: 'annual-pass',
    ...(rest && convertKeysToSnakeCase(rest)),
  }

  track(EventTypes.PURCHASE_CLICK, properties)
}
